import { Component, OnInit, Input } from '@angular/core';
import { LoginService } from './../../login/login.service';
import { LoginSettings } from './../../login/loginSetting.model';

@Component({
  selector: 'login-footer',
  templateUrl: './login-footer.component.html',
  styleUrls: ['./login-footer.component.css']
})
export class LoginFooterComponent implements OnInit {
  @Input() userType: number;
  LoginSettings: LoginSettings;
  copyrightYear: number;

  constructor(
    private loginService: LoginService
  ) {
  }

  ngOnInit() {
    this.LoginSettings = this.loginService.LoginSettings;
    this.copyrightYear = new Date().getFullYear();
  }

  currentApplicationClick() {
    window.localStorage.setItem('NewApplication', '0');
    const currentApplicationUrl = window.location.href.substring(0, window.location.href.indexOf('360') + 3);
    window.location.replace(currentApplicationUrl);
  }
}